import { useEffect } from "react";

const useDocumentTitle = (pageTitle) => {
  useEffect(() => {
    // ACCESSIBILITY: update document.title on mount so screen readers
    // and browser tabs always reflect the current page
    document.title = pageTitle
      ? `${pageTitle} | Nuvama API Connect`
      : "Nuvama API Connect";

    // ACCESSIBILITY: restore a generic title on unmount so if the next
    // page forgets to set a title it doesn't show a stale one
    return () => {
      document.title = "Nuvama API Connect";
    };
  }, [pageTitle]);
};

export default useDocumentTitle;